import script from "./SguResponses.vue?vue&type=script&setup=true&lang=js"
export * from "./SguResponses.vue?vue&type=script&setup=true&lang=js"

import "./SguResponses.vue?vue&type=style&index=0&id=61380956&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61380956"]])

export default __exports__